import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vanxuan/project/vanxuan/web-user/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/home/vanxuan/project/vanxuan/web-user/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.jsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/vanxuan/project/vanxuan/web-user/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/vanxuan/project/vanxuan/web-user/node_modules/aos/dist/aos.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vanxuan/project/vanxuan/web-user/src/components/layouts/Index.jsx");
;
import(/* webpackMode: "eager" */ "/home/vanxuan/project/vanxuan/web-user/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/home/vanxuan/project/vanxuan/web-user/src/styles/embla.scss");
